export const custNav = [
    {
        name: "Users",
        img: "/assets/svgs/userFriend.svg",
        link: "/user"
    },
    {
        name: "Guarantors",
        img: "/assets/svgs/guarantor.svg",
        link: "/guarantors"
    },
    {
        name: "Loans",
        img: "/assets/svgs/loans.svg",
        link: "/loans"
    },
    {
        name: "Decision Models",
        img: "/assets/svgs/decisionModels.svg",
        link: ""
    },
    {
        name: "Savings",
        img: "/assets/svgs/savings.svg",
        link: ""
    },
    {
        name: "Loan Requests",
        img: "/assets/svgs/loanRequests.svg",
        link: ""
    },
    {
        name: "Whitelist",
        img: "/assets/svgs/whitelist.svg",
        link: ""
    },
    {
        name: "Karma",
        img: "/assets/svgs/karma.svg",
        link: ""
    },
]

export const busNav = [
    {
        name: "Organization",
        img: "/assets/svgs/organization.svg",
        link: ""
    },
    {
        name: "Loan Products",
        img: "/assets/svgs/loanProducts.svg",
        link: ""
    },
    {
        name: "Savings Products",
        img: "/assets/svgs/savingsProducts.svg",
        link: ""
    },
    {
        name: "Fees and Charges",
        img: "/assets/svgs/feesAndCharges.svg",
        link: ""
    },
    {
        name: "Transactions",
        img: "/assets/svgs/transactions.svg",
        link: ""
    },
    {
        name: "Services",
        img: "/assets/svgs/services.svg",
        link: ""
    },
    {
        name: "Service Amount",
        img: "/assets/svgs/serviceAccount.svg",
        link: ""
    },
    {
        name: "Settlements",
        img: "/assets/svgs/settlements.svg",
        link: ""
    },
    {
        name: "Reports",
        img: "/assets/svgs/reports.svg",
        link: ""
    },
]

export const settNav = [
    {
        name: "Preferences",
        img: "/assets/svgs/preferences.svg",
        link: ""
    },
    {
        name: "Fees and Pricing",
        img: "/assets/svgs/feesAndCharges.svg",
        link: ""
    },
    {
        name: "Audit Logs",
        img: "/assets/svgs/auditLogs.svg",
        link: ""
    },
    {
        name: "Audit Logs",
        img: "/assets/svgs/auditLogs.svg",
        link: ""
    }, {
        name: "Audit Logs",
        img: "/assets/svgs/auditLogs.svg",
        link: ""
    },

]